import { ActionTypes, SensorIdMappingActions } from './sensor-id-mapping.actions';
import { SensorIdMappingState } from './sensor-id-mapping.model';

export const sensorIdMappingState: SensorIdMappingState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getSensorIdMappingLoading: false,
  getSensorIdMappingLoaded: false,
  sensorIdMapping: null,
  addSensorIdMappingLoading: false,
  addSensorIdMappingLoaded: false,
  editSensorIdMappingLoading: false,
  editSensorIdMappingLoaded: false,
  deleteSensorIdMappingsLoading: false,
  deleteSensorIdMappingsLoaded: false,
  changeActivitiesDataLoading: false,
  changeActivitiesDataLoaded: false,
  changeActivitiesData: [],
};

export function sensorIdMappingReducer(
  state: SensorIdMappingState = sensorIdMappingState,
  action: SensorIdMappingActions,
): SensorIdMappingState {
  switch (action.type) {
    case ActionTypes.SENSOR_ID_MAPPINGS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.SENSOR_ID_MAPPINGS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_SENSOR_ID_MAPPING:
      return {
        ...state,
        getSensorIdMappingLoading: true,
        getSensorIdMappingLoaded: false,
      };
    case ActionTypes.GET_SENSOR_ID_MAPPING_COMPLETED:
      return {
        ...state,
        sensorIdMapping: action.payload.data,
        getSensorIdMappingLoading: false,
        getSensorIdMappingLoaded: true,
      };
    case ActionTypes.ADD_SENSOR_ID_MAPPING:
      return {
        ...state,
        addSensorIdMappingLoading: true,
        addSensorIdMappingLoaded: false,
      };
    case ActionTypes.ADD_SENSOR_ID_MAPPING_COMPLETED:
      return {
        ...state,
        addSensorIdMappingLoading: false,
        addSensorIdMappingLoaded: true,
      };
    case ActionTypes.EDIT_SENSOR_ID_MAPPING:
      return {
        ...state,
        editSensorIdMappingLoading: true,
        editSensorIdMappingLoaded: false,
      };
    case ActionTypes.EDIT_SENSOR_ID_MAPPING_COMPLETED:
      return {
        ...state,
        editSensorIdMappingLoading: false,
        editSensorIdMappingLoaded: true,
      };
    case ActionTypes.DELETE_SENSOR_ID_MAPPINGS:
      return {
        ...state,
        deleteSensorIdMappingsLoading: true,
        deleteSensorIdMappingsLoaded: false,
      };
    case ActionTypes.DELETE_SENSOR_ID_MAPPINGS_COMPLETED:
      return {
        ...state,
        deleteSensorIdMappingsLoading: false,
        deleteSensorIdMappingsLoaded: true,
      };
    case ActionTypes.CHANGE_ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        changeActivitiesDataLoading: true,
        changeActivitiesDataLoaded: false,
      };
    case ActionTypes.CHANGE_ACTIVITIES_DATA_COMPLETED:
      return {
        ...state,
        changeActivitiesData: action.payload,
        changeActivitiesDataLoading: false,
        changeActivitiesDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
